import { constants } from '@wsb/guac-widget-core';
import {
  FILL,
  FIT,
  INSET,
  BLUR,
  LEGACY_BLUR,
  WIDE_INSET,
  FLEX_FILL
} from '../../common/constants/headerTreatments';
import { COMMON_BUTTON_CONFIG } from '../../common/constants';
import imageToHeaderTreatments from '../../common/utils/imageToHeaderTreatments';
import { IMAGE, VIDEO, SLIDESHOW, NONE } from '../../common/constants/mediaTypes';
import { TREATMENTS } from './treatments';

const {
  colorPackCategories: { NEUTRAL, ACCENT },
  buttons,
  contentPositions: { CENTER }
} = constants;
const { LIGHT, LIGHT_ALT, LIGHT_COLORFUL, DARK, DARK_ALT, DARK_COLORFUL, COLORFUL, CUSTOM } =
  constants.paintJobs;

const id = 'layout28';
const imageTreatments = {
  [FILL]: 'accent-overlay',
  [FIT]: 'accent-overlay',
  [INSET]: 'category-solid',
  [BLUR]: 'accent-overlay',
  [LEGACY_BLUR]: 'accent-overlay',
  [WIDE_INSET]: 'category-solid',
  [FLEX_FILL]: 'accent-overlay'
};

const defaultHeaderTreatment = FILL;
const headerTreatments = imageToHeaderTreatments(imageTreatments);
const headerTreatmentsConfig = {
  imageTreatments,
  defaultHeaderTreatment,
  headerTreatments,
  heroContentItems: ['tagline', 'tagline2', 'cta'],
  nonHeroContentItems: ['phone'],
  heroJustifyContent: 'flex-end',
  defaultProps: {
    [FLEX_FILL]: {
      fullWidthMedia: false,
      hasNavWithBackground: false,
      roundedCorners: true,
      category: NEUTRAL,
      contentPosition: CENTER,
      alignment: 'center'
    },
    [FILL]: {
      hasNavWithBackground: false
    },
    [FIT]: {
      hasNavWithBackground: false
    }
  },
  mediaSupport: {
    [NONE]: [defaultHeaderTreatment],
    [IMAGE]: Object.keys(imageTreatments),
    [VIDEO]: [defaultHeaderTreatment, FLEX_FILL],
    [SLIDESHOW]: [defaultHeaderTreatment, FLEX_FILL]
  }
};
const defaultPaintJob = CUSTOM;

export default {
  id,
  name: 'kai',
  packs: {
    color: '#75978D',
    font: 'karla'
  },
  logo: {
    font: 'primary'
  },
  packCategories: {
    color: ACCENT
  },
  headerProperties: {
    alignmentOption: 'left',
    defaultLogoAlign: 'center'
  },
  headerTreatmentsConfig,
  showSlideshowTab: true,
  hasNavBackground: false,
  paintJobs: [LIGHT, LIGHT_ALT, LIGHT_COLORFUL, COLORFUL, DARK_COLORFUL, DARK_ALT, DARK],
  defaultPaintJob,
  buttons: {
    treatments: [
      TREATMENTS.SOLID,
      TREATMENTS.OUTLINE,
      TREATMENTS.LINK,
      TREATMENTS.GLASS,
      TREATMENTS.DIAGONAL_STRIPED,
      TREATMENTS.TEXT_ICON,
      TREATMENTS.WAVY
    ],
    primary: {
      fill: buttons.fills.GHOST,
      shape: buttons.shapes.PILL,
      decoration: buttons.decorations.NONE,
      shadow: buttons.shadows.NONE,
      color: buttons.colors.HIGHCONTRAST
    },
    secondary: {
      fill: buttons.fills.GHOST,
      decoration: buttons.decorations.NONE,
      shadow: buttons.shadows.NONE,
      color: buttons.colors.HIGHCONTRAST
    },
    ...COMMON_BUTTON_CONFIG
  },
  defaultNavFamily: 'nav10',
  hasLogoOverhang: true,
  hasStickyNav: false,
  hasLogoBorder: false
};
